import { CurrencyPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { PortalToBodyDirective } from 'src/app/directives/portal-to-body.directive';
import { PublicCatalogBenefit, PublicCatalogItem, PublicCatalogMedia, PublicCatalogPlan } from 'src/app/models/catalogs/public-catalog';
import { environment } from 'src/environments/environment';
import { ImagePreviewComponent } from "src/app/components/shared/image-preview/image-preview.component";
import { PeriodLabelPipe } from "../../../../pipes/period-label.pipe";

@Component({
  selector: 'app-public-catalog-detail',
  templateUrl: './public-catalog-detail.component.html',
  styleUrls: ['./public-catalog-detail.component.css'],
  imports: [NgClass, CurrencyPipe, NgIf, NgFor, PortalToBodyDirective, ImagePreviewComponent, PeriodLabelPipe]
})
export class PublicCatalogDetailComponent implements OnChanges {
  @Input() item: PublicCatalogItem | null = null;

  media: PublicCatalogMedia[] = [];
  benefits: PublicCatalogBenefit[] = [];
  plans: PublicCatalogPlan[] = [];

  pdfPreviewSafe: SafeResourceUrl | null = null;
  pdfPreviewName = '';

  private sanitizer = inject(DomSanitizer);

  fileBaseUrl = `${environment.api.url}/File/ViewFile`;

  safeDescription: SafeHtml | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && this.item) {
      this.media = this.item.media ?? [];
      this.benefits = this.item.benefits ?? [];
      this.plans = this.item.plans ?? [];
      if (this.item?.longDescription) {
        this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(this.item.longDescription);
      }
    }
  }

  get mainActionLabel(): string {
    if (!this.item) return 'Seleccionar';
    return this.item.functionalTypeName?.toLowerCase() === 'servicio'
      ? 'Solicitar'
      : 'Comprar';
  }

  onMainAction(plan?: PublicCatalogPlan): void {
    if (!this.item) return;
    if (plan) {
      console.log(
        `Acción: ${this.mainActionLabel} plan ${plan.name} de ${this.item.title}`
      );
    } else {
      console.log(`Acción: ${this.mainActionLabel} ${this.item.title}`);
    }
  }

  // ---- Multimedia helpers ----
  isImage(m: PublicCatalogMedia): boolean {
    return (m.mediaType || '').toUpperCase() === 'IMAGE';
  }

  isVideo(m: PublicCatalogMedia): boolean {
    return (m.mediaType || '').toUpperCase() === 'VIDEO';
  }

  isPdf(m: PublicCatalogMedia): boolean {
    return (m.mediaType || '').toUpperCase() === 'PDF';
  }

  openPdf(m: PublicCatalogMedia): void {
    const src = `${this.fileBaseUrl}/${m.fileId}`;
    this.pdfPreviewSafe = this.sanitizer.bypassSecurityTrustResourceUrl(src);
    this.pdfPreviewName = m.caption || 'Documento.pdf';

    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('pdfModal')
    );
    modal.show();
  }

  playVideo(vid: HTMLVideoElement, overlay: HTMLElement, ev?: Event) {
    ev?.stopPropagation();
    overlay.style.display = 'none';
    vid.setAttribute('controls', 'true');
    vid.muted = false;
    vid.play();
  }

  hideOverlay(overlay: HTMLElement) {
    overlay.style.display = 'none';
  }

  showOverlay(overlay: HTMLElement) {
    overlay.style.display = 'flex';
  }
}